var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIonicLogoTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.415,
    height: 12.544,
    viewBox: "0 0 15.415 12.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M16.829,5.986a6.394,6.394,0,0,1-1.816.5A3.174,3.174,0,0,0,16.4,4.735a6.284,6.284,0,0,1-2.009.768A3.162,3.162,0,0,0,8.923,7.665,3.1,3.1,0,0,0,9,8.387a8.963,8.963,0,0,1-6.52-3.309,3.169,3.169,0,0,0,.983,4.227,3.089,3.089,0,0,1-1.437-.4v.039a3.165,3.165,0,0,0,2.538,3.1,3.184,3.184,0,0,1-.833.111,2.983,2.983,0,0,1-.595-.059A3.168,3.168,0,0,0,6.1,14.3a6.341,6.341,0,0,1-3.93,1.356,6.411,6.411,0,0,1-.755-.046,8.84,8.84,0,0,0,4.841,1.431,8.945,8.945,0,0,0,9.006-9.009c0-.137,0-.274-.01-.408A6.438,6.438,0,0,0,16.829,5.986Z",
    transform: "translate(-1.413 -4.5)",
    fill: "#f49a56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicLogoTwitter);
export default __webpack_public_path__ + "static/media/icon-ionic-logo-twitter.76e492c44a5cd1d9a373378e7c417754.svg";
export { ForwardRef as ReactComponent };